import React from 'react';
import PropTypes from 'prop-types';

import {
    Grid,
} from '@material-ui/core';

import BillingPlanInfo from './billingPlanInfo';
import BillingAddOns from './billingAddOns';
import { useStyles } from './styles';

function BillingForm (props) {
    const {
        billingInputProps,
    } = props;

    const {
        input,
        updateInput,
        planDetail,
        plans,
        selectPlan,
        addOns,
        updateAddOnsValue,
        addOnsValues,
        addOnsDisabled,
    } = billingInputProps;

    const classes = useStyles();

    return (
        <React.Fragment>
            <Grid
                container
                className={classes.planFormContainer}
                >

                <BillingPlanInfo
                    input={input}
                    planDetail={planDetail}
                    plans={plans}
                    selectPlan={selectPlan}
                    billingInputProps={billingInputProps}
                />

                <BillingAddOns
                    addOns={addOns}
                    input={input}
                    updateInput={updateInput}
                    updateAddOnsValue={updateAddOnsValue}
                    addOnsValues={addOnsValues}
                    addOnsDisabled={addOnsDisabled}
                    billingInputProps={billingInputProps}
                />

            </Grid>
        </React.Fragment>
    );
}

BillingForm.propTypes = {
    billingInputProps: PropTypes.object,
};

BillingForm.defaultProps = {
    billingInputProps: {},
};

export default BillingForm;
